import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { GlobalErrorBoundary } from './components/Diagnostic/GlobalErrorBoundary';
import { initBackgroundReloadGuard } from './lib/backgroundReloadGuard';
import './index.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Garde anti-page-blanche au retour de background (mobile) — exécuté une seule
// fois au démarrage, avant le render React.
initBackgroundReloadGuard();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>
);